export default __webpack_public_path__ + "static/media/58-min.9443bcf5.jpg";